// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialCostPageQueryVariables = Types.Exact<{
  variantId: Types.Scalars['ID']['input'];
}>;


export type MaterialCostPageQuery = { __typename?: 'Query', materialVariantCostSources: { __typename?: 'MaterialVariantCostSourcesPage', entities: Array<
      | { __typename: 'BidItemEstimate', createdAt: Types.Scalars['DateTime']['input'], costInMills: number, id: string, sourceUrl?: string | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, bidItemEstimate: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } }
      | { __typename: 'BidContractLineItem', id: string, createdAt: Types.Scalars['DateTime']['input'], unitCostInMills: number, bidItem?: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } | null | undefined, revision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, relevantMarket: { __typename?: 'Market', id: string, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, awards: Array<{ __typename?: 'BidPackageAward', id: string, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined }> } } | null | undefined } } }
    > } };

export type Estimate_MaterialCostPageFragment = { __typename?: 'BidItemEstimate', createdAt: Types.Scalars['DateTime']['input'], costInMills: number, id: string, sourceUrl?: string | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, bidItemEstimate: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } };

export type LineItem_MaterialCostPageFragment = { __typename?: 'BidContractLineItem', id: string, createdAt: Types.Scalars['DateTime']['input'], unitCostInMills: number, bidItem?: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } | null | undefined, revision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, relevantMarket: { __typename?: 'Market', id: string, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, awards: Array<{ __typename?: 'BidPackageAward', id: string, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined }> } } | null | undefined } } };

export const Estimate_MaterialCostPageFragmentDoc = gql`
    fragment Estimate_MaterialCostPage on BidItemEstimate {
  createdAt
  createdBy {
    id
    name
  }
  costInMills
  id
  markets {
    id
    name
  }
  bidItemEstimate: bidItem {
    id
    unitOfMeasure {
      id
      abbreviation
    }
  }
  sourceUrl
}
    `;
export const LineItem_MaterialCostPageFragmentDoc = gql`
    fragment LineItem_MaterialCostPage on BidContractLineItem {
  id
  createdAt
  unitCostInMills
  bidItem {
    id
    unitOfMeasure {
      id
      abbreviation
    }
  }
  revision {
    id
    bidContract {
      id
      relevantMarket {
        ...Named
      }
      tradePartner {
        id
        name
      }
      bidRequest {
        id
        bidPackage {
          id
          name
          bidPackageGroup {
            id
          }
          awards {
            id
            primaryRevision {
              id
            }
            secondaryRevision {
              id
            }
          }
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const MaterialCostPageDocument = gql`
    query MaterialCostPage($variantId: ID!) {
  materialVariantCostSources(materialVariantId: $variantId) {
    entities {
      __typename
      ... on BidContractLineItem {
        ...LineItem_MaterialCostPage
      }
      ... on BidItemEstimate {
        ...Estimate_MaterialCostPage
      }
    }
  }
}
    ${LineItem_MaterialCostPageFragmentDoc}
${Estimate_MaterialCostPageFragmentDoc}`;

/**
 * __useMaterialCostPageQuery__
 *
 * To run a query within a React component, call `useMaterialCostPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialCostPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialCostPageQuery({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useMaterialCostPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialCostPageQuery, MaterialCostPageQueryVariables> & ({ variables: MaterialCostPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialCostPageQuery, MaterialCostPageQueryVariables>(MaterialCostPageDocument, options);
      }
export function useMaterialCostPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialCostPageQuery, MaterialCostPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialCostPageQuery, MaterialCostPageQueryVariables>(MaterialCostPageDocument, options);
        }
// @ts-ignore
export function useMaterialCostPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialCostPageQuery, MaterialCostPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCostPageQuery, MaterialCostPageQueryVariables>;
export function useMaterialCostPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCostPageQuery, MaterialCostPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCostPageQuery | undefined, MaterialCostPageQueryVariables>;
export function useMaterialCostPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCostPageQuery, MaterialCostPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialCostPageQuery, MaterialCostPageQueryVariables>(MaterialCostPageDocument, options);
        }
export type MaterialCostPageQueryHookResult = ReturnType<typeof useMaterialCostPageQuery>;
export type MaterialCostPageLazyQueryHookResult = ReturnType<typeof useMaterialCostPageLazyQuery>;
export type MaterialCostPageSuspenseQueryHookResult = ReturnType<typeof useMaterialCostPageSuspenseQuery>;
export type MaterialCostPageQueryResult = Apollo.QueryResult<MaterialCostPageQuery, MaterialCostPageQueryVariables>;